var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _g2, _rect, _path19, _rect2, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrapperIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 312,
    height: 264,
    viewBox: "0 0 312 264",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.543 63V130.357",
    stroke: "url(#paint0_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0898 63V130.357",
    stroke: "url(#paint1_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.641 63V130.357",
    stroke: "url(#paint2_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M122.188 63V130.357",
    stroke: "url(#paint3_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M140.742 63V130.357",
    stroke: "url(#paint4_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M159.289 63V130.357",
    stroke: "url(#paint5_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53 111.574H173.563",
    stroke: "url(#paint6_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53 92.793H173.563",
    stroke: "url(#paint7_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53 74.0117H173.563",
    stroke: "url(#paint8_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M164.957 133.301V200.658",
    stroke: "url(#paint9_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M183.504 133.301V200.658",
    stroke: "url(#paint10_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M202.055 133.301V200.658",
    stroke: "url(#paint11_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M220.602 133.301V200.658",
    stroke: "url(#paint12_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M239.156 133.301V200.658",
    stroke: "url(#paint13_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M257.703 133.301V200.658",
    stroke: "url(#paint14_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M155.93 181.227H276.492",
    stroke: "url(#paint15_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M155.93 162.445H276.492",
    stroke: "url(#paint16_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M155.93 143.664H276.492",
    stroke: "url(#paint17_linear_1877_14537)",
    strokeOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1877_14537)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 109.782,
    cy: 153.945,
    rx: 35.782,
    ry: 35.9454,
    fill: "#A556FF",
    fillOpacity: 0.28
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1877_14537)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 200.071,
    cy: 111.241,
    rx: 37.0714,
    ry: 37.2407,
    fill: "#7600FC",
    fillOpacity: 0.4
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 87.8672,
    y: 137.184,
    width: 50.5776,
    height: 50.5776,
    rx: 8.5,
    fill: "#1F0745",
    fillOpacity: 0.56,
    stroke: "url(#paint18_linear_1877_14537)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M123 155L104 162.5L111 163.5M123 155L120.5 170L111 163.5M123 155L111 163.5M111 163.5V169L114.249 165.723",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 188.605,
    y: 71.6055,
    width: 50.5776,
    height: 50.5776,
    rx: 8.5,
    fill: "#1F0745",
    fillOpacity: 0.56,
    stroke: "url(#paint19_linear_1877_14537)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M206 105L212.709 98.2907M212.709 98.2907L206 89H210.444L215.291 95.7093M212.709 98.2907L217.556 105H222L215.291 95.7093M222 89L215.291 95.7093",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1877_14537",
    x: 0,
    y: 44,
    width: 219.562,
    height: 219.891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37,
    result: "effect1_foregroundBlur_1877_14537"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1877_14537",
    x: 89,
    y: 0,
    width: 222.145,
    height: 222.48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37,
    result: "effect1_foregroundBlur_1877_14537"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1877_14537",
    x1: 67.043,
    y1: 63,
    x2: 67.043,
    y2: 130.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1877_14537",
    x1: 85.5898,
    y1: 63,
    x2: 85.5898,
    y2: 130.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1877_14537",
    x1: 104.141,
    y1: 63,
    x2: 104.141,
    y2: 130.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1877_14537",
    x1: 122.688,
    y1: 63,
    x2: 122.688,
    y2: 130.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1877_14537",
    x1: 141.242,
    y1: 63,
    x2: 141.242,
    y2: 130.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1877_14537",
    x1: 159.789,
    y1: 63,
    x2: 159.789,
    y2: 130.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1877_14537",
    x1: 53,
    y1: 111.074,
    x2: 173.563,
    y2: 111.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1877_14537",
    x1: 53,
    y1: 92.293,
    x2: 173.563,
    y2: 92.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1877_14537",
    x1: 53,
    y1: 73.5117,
    x2: 173.563,
    y2: 73.5117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1877_14537",
    x1: 165.457,
    y1: 133.301,
    x2: 165.457,
    y2: 200.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1877_14537",
    x1: 184.004,
    y1: 133.301,
    x2: 184.004,
    y2: 200.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1877_14537",
    x1: 202.555,
    y1: 133.301,
    x2: 202.555,
    y2: 200.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1877_14537",
    x1: 221.102,
    y1: 133.301,
    x2: 221.102,
    y2: 200.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1877_14537",
    x1: 239.656,
    y1: 133.301,
    x2: 239.656,
    y2: 200.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1877_14537",
    x1: 258.203,
    y1: 133.301,
    x2: 258.203,
    y2: 200.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1877_14537",
    x1: 155.93,
    y1: 180.727,
    x2: 276.492,
    y2: 180.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1877_14537",
    x1: 155.93,
    y1: 161.945,
    x2: 276.492,
    y2: 161.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1877_14537",
    x1: 155.93,
    y1: 143.164,
    x2: 276.492,
    y2: 143.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177745,
    stopColor: "white",
    stopOpacity: 0.560083
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559714,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783845,
    stopColor: "white",
    stopOpacity: 0.702453
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1877_14537",
    x1: 113.156,
    y1: 136.684,
    x2: 113.5,
    y2: 196.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7057F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249483,
    stopColor: "#6E5BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1877_14537",
    x1: 213.894,
    y1: 71.1055,
    x2: 214.238,
    y2: 130.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7057F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249483,
    stopColor: "#6E5BCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#666666",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrapperIcon);
export default __webpack_public_path__ + "static/media/ScrapperIcon.a82412c32152cf3cdffc42f87ef035da.svg";
export { ForwardRef as ReactComponent };